import type { Event } from '~/types/strapi';
import type { EventArchive } from '~/types/api';

// generates idempotent slug for event
export const useEventSlugGenerator = (event: Event | EventArchive['events'][number]) => {
  // at this point the two possible types are Event and EventArchive['events'][number]
  // so we need to check which one is passed, but in the use case we only care about the 'title' property
  // which is present in both types
  let title = 'event-';
  if ('title' in event) {
    title += event.title;
  }

  return title.toLowerCase().replace(/ /g, '-');
};
